---
title: Fishing Regions
description: A starter hub for thinking about fishing regions, local rules, habitat, seasons, and trip planning.
---

# Fishing Regions

Every region has its own water, rules, seasons, and access patterns. Use Roddo as a planning and learning tool, then confirm the details locally.

## Start here

- [Fishing map guide](/learn/fishing-map)
- [Fishing safety reminders](/learn/fishing-safety)
- [FishIQ guide](/learn/fishiq)
